var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"report-btn",attrs:{"icon":"","small":""},on:{"click":_vm.setEmail}},[_c('v-icon',{attrs:{"small":"","color":"blue"}},[_vm._v("send")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }